module.exports = {"Phase 1":{"HZ 01":[],"HZ 02":[],"HZ 03":[],"HZ 04":[]},"Phase 2":{"HZ 05":[],"HZ 06":[],"HZ 07":[]},"Phase 3":{"HZ 08":[],"HZ 09":[],"HZ 10":[]},"Phase 4":{"HZ 11":[],"HZ 12":[],"HZ 13":[],"HZ 14":[],"HZ 15":[]}}


//////////////////
// WEBPACK FOOTER
// ./src/data/eastbrook.json
// module id = 114
// module chunks = 0